export default (name, key) => {
  const translatesStore = useTranslatesStore();
  try {
    translatesStore.GET_Translate_Request(name);
    const value = translatesStore.GET_Translates[name][key];
    return value || name + "." + key;
  } catch (e) {
    return name + "." + key;
  }
};
